import React from "react";
import { Link } from "react-router-dom";
import { useRecoilState } from "recoil";
import { AdminMenus } from "../../../components/recoil/atoms/Menus";

function Menus() {
  const [varAdminMenus] = useRecoilState(AdminMenus);
  
  //로그인뮤우
  const adminLoginState = Number(localStorage.getItem('adminLoginState'));
  const adminMode = Number(localStorage.getItem("adminMode"));

  return !adminLoginState?null:(
    <div id="left-wraps">
      <Link to="/MainAdmin"><div className="logo"><p className="h1">마마몽떼 관리시스템</p></div></Link>
      <div id="gnbs">
        {varAdminMenus.type === "BRANCH"?
          <ul className="depth1">
            <li className={varAdminMenus.item === "Branches" 
                          || varAdminMenus.item === "Royalty" ? "selectedmenu" : ""}>
              <div>센터 관리</div>
              <ul className="depth2">
                <li className="m03">
                  <Link to={"/Admin/BranchList"}>
                    <span className={varAdminMenus.item === "Branches" ? "selectedlimenu" : ""}>- 센터 관리</span>
                  </Link>
                </li>
                <li className="m03">
                  <Link to={"/Admin/RoyaltyInformation"}>
                    <span className={varAdminMenus.item === "Royalty" ? "selectedlimenu" : ""}>- 로열티 설정</span>
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
        :varAdminMenus.type === "COURSE"?
          <ul className="depth1">
            <li className={varAdminMenus.item === "Courses" ? "selectedmenu" : ""}>
              <div>수강 관리</div>
              <ul className="depth2">
                <li className="m03">
                  <Link to={"/Admin/CourseList"}>
                    <span className={varAdminMenus.item === "Courses" ? "selectedlimenu" : ""}>- 수강 관리</span>
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
        :varAdminMenus.type === "MEMBER"?
          <ul className="depth1">
            <li className={varAdminMenus.item === "Members" ? "selectedmenu" : ""}>
              <div>회원 관리</div>
              <ul className="depth2">
                <li className="m03">
                  <Link to={"/Admin/MemberList"}>
                    <span className={varAdminMenus.item === "Members" ? "selectedlimenu" : ""}>- 회원 관리</span>
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
        :varAdminMenus.type === "ANALYSIS"?
          <ul className="depth1">
            <li className={varAdminMenus.item === "Analysis" ? "selectedmenu" : ""}>
              <div>발달분석 및 평가</div>
              <ul className="depth2">
                <li className="m03">
                  <Link to={"/Admin/AnalysisList"}>
                    <span className={varAdminMenus.item === "Analysis" ? "selectedlimenu" : ""}>- 발달분석 및 평가</span>
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
        :varAdminMenus.type === "CERTIFICATION"?
          <ul className="depth1">
            <li className={varAdminMenus.item === "Certification" ? "selectedmenu" : ""}>
              <div>수료증 관리</div>
              <ul className="depth2">
                <li className="m03">
                  <Link to={"/Admin/CertificationList"}>
                    <span className={varAdminMenus.item === "Certification" ? "selectedlimenu" : ""}>- 수료증 관리</span>
                  </Link>
                </li>
              </ul>
            </li>
          </ul>   
        :varAdminMenus.type === "PAYMENT"?
          <ul className="depth1">
            <li className={varAdminMenus.item === "Payment" ? "selectedmenu" : ""}>
              <div>결제 관리</div>
              <ul className="depth2">
                <li className="m03">
                  <Link to={"/Admin/PaymentList"}>
                    <span className={varAdminMenus.item === "Payment" ? "selectedlimenu" : ""}>- 결제 관리</span>
                  </Link>
                </li>
              </ul>
            </li>
          </ul>      
        :varAdminMenus.type === "SALES"?
          <ul className="depth1">
            <li className={varAdminMenus.item === "SalesReport" ? "selectedmenu" : ""}>
              <div>매출 리포트</div>
              <ul className="depth2">
                <li className="m03">
                  <Link to={"/Admin/SalesList"}>
                    <span className={varAdminMenus.item === "SalesReport" ? "selectedlimenu" : ""}>- 매출 리포트</span>
                  </Link>
                </li>
              </ul>
            </li>
          </ul> 
        :varAdminMenus.type === "SETTLEMENT"?
          <ul className="depth1">
            <li className={varAdminMenus.item === "Settlement" || varAdminMenus.item === "TextBook" ? "selectedmenu" : ""}>
              <div>정산현황 관리</div>
              <ul className="depth2">
                <li className="m03">
                  <Link to={"/Admin/SettlementList"}>
                    <span className={varAdminMenus.item === "Settlement" ? "selectedlimenu" : ""}>- 정산 현황</span>
                  </Link>
                </li>
                <li className="m03">
                  <Link to={"/Admin/TextBookList"}>
                    <span className={varAdminMenus.item === "TextBook" ? "selectedlimenu" : ""}>- 교재 확인</span>
                  </Link>
                </li>
              </ul>
            </li>
          </ul> 
        :varAdminMenus.type === "VARIABLES"?
          <ul className="depth1">
            <li className={varAdminMenus.item === "Business" 
                          || varAdminMenus.item === "ChildrenLevel" 
                          || varAdminMenus.item === "SettlementSerious" 
                          || varAdminMenus.item === "FaqType" 
                          || varAdminMenus.item === "TextBooks" 
                          || varAdminMenus.item === "Mamamonte" 
                          || varAdminMenus.item === "Fly" 
                          ? "selectedmenu" : ""}>
              <div>변수설정</div>
              <ul className="depth2">
                <li className="m03">
                  <Link to={"/Admin/Business"}>
                    <span className={varAdminMenus.item === "Business" ? "selectedlimenu" : ""}>- 업종</span>
                  </Link>
                </li>
                <li className="m03">
                  <Link to={"/Admin/ChildrenLevel"}>
                    <span className={varAdminMenus.item === "ChildrenLevel" ? "selectedlimenu" : ""}>- 원생등급</span>
                  </Link>
                </li>
                <li className="m03">
                  <Link to={"/Admin/SettlementSerious"}>
                    <span className={varAdminMenus.item === "SettlementSerious" ? "selectedlimenu" : ""}>- 정산품목</span>
                  </Link>
                </li>
                <li className="m03">
                  <Link to={"/Admin/FaqType"}>
                    <span className={varAdminMenus.item === "FaqType" ? "selectedlimenu" : ""}>- 문의종류</span>
                  </Link>
                </li>
                <li className="m03">
                  <Link to={"/Admin/TextBooks"}>
                    <span className={varAdminMenus.item === "TextBooks" ? "selectedlimenu" : ""}>- 교재</span>
                  </Link>
                </li>
                <li className="m03">
                  <Link to={"/Admin/Mamamonte"}>
                    <span className={varAdminMenus.item === "Mamamonte" ? "selectedlimenu" : ""}>- 마마몽떼</span>
                  </Link>
                </li>
                <li className="m03">
                  <Link to={"/Admin/Fly"}>
                    <span className={varAdminMenus.item === "Fly" ? "selectedlimenu" : ""}>- 플라이</span>
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
        :varAdminMenus.type === "ENVIRONMENT"?
          <ul className="depth1">
            <li className={varAdminMenus.item === "FAQ" 
                          || varAdminMenus.item === "Notice" 
                          || varAdminMenus.item === "Service" 
                          || varAdminMenus.item === "Privacy" 
                          || varAdminMenus.item === "Refund" 
                          || varAdminMenus.item === "Marketing" 
                          || varAdminMenus.item === "AdminInformation" 
                          || varAdminMenus.item === "SubAdminInformation" 
                          ? "selectedmenu" : ""}>
              <div>설정</div>
              <ul className="depth2">
                <li className="m03">
                  <Link to={"/Admin/FaqList"}>
                    <span className={varAdminMenus.item === "FAQ" ? "selectedlimenu" : ""}>- FAQ이용안내</span>
                  </Link>
                </li>
                <li className="m03">
                  <Link to={"/Admin/NoticeList"}>
                    <span className={varAdminMenus.item === "Notice" ? "selectedlimenu" : ""}>- 공지사항</span>
                  </Link>
                </li>
                <li className="m03">
                  <Link to={"/Admin/AdminTerm/1"}>
                    <span className={varAdminMenus.item === "Service" ? "selectedlimenu" : ""}>- 이용약관</span>
                  </Link>
                </li>
                <li className="m03">
                  <Link to={"/Admin/AdminTerm/2"}>
                    <span className={varAdminMenus.item === "Privacy" ? "selectedlimenu" : ""}>- 개인정보처리방침</span>
                  </Link>
                </li>
                <li className="m03">
                  <Link to={"/Admin/AdminTerm/3"}>
                    <span className={varAdminMenus.item === "Refund" ? "selectedlimenu" : ""}>- 환불취소정책동의</span>
                  </Link>
                </li>
                <li className="m03">
                  <Link to={"/Admin/AdminTerm/4"}>
                    <span className={varAdminMenus.item === "Marketing" ? "selectedlimenu" : ""}>- 마케팅정보이용동의</span>
                  </Link>
                </li>
                <li className="m03">
                  <Link to={"/Admin/AdminInformation"}>
                    <span className={varAdminMenus.item === "AdminInformation" ? "selectedlimenu" : ""}>-관리자정보수정</span>
                  </Link>
                </li>  
                {adminMode===2?null
                :<li className="m03">
                  <Link to={"/Admin/SubAdminInformation"}>
                    <span className={varAdminMenus.item === "SubAdminInformation" ? "selectedlimenu" : ""}>-부운영자관리</span>
                  </Link>
                </li>
                }
              </ul>
            </li>
          </ul>
        :null}
      </div>
    </div>
  );
}

export default Menus;
